module.exports = __webpack_public_path__ + "img/social-twitter.54e9b01a.svg";